// extracted by mini-css-extract-plugin
export default {"pageContainer":"Feedback_pageContainer__J8eN2","pageHeader":"Feedback_pageHeader__u53Ry","pageContent":"Feedback_pageContent__evZvN","fluidContent":"Feedback_fluidContent__9b2Iw"};